import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get("/blog")
      .then((r) => setPosts(r.data))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="blog-page">
      <div className="overline mb-3">/blog — network updates & guides</div>
      <h1 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter mb-10">
        Field notes
      </h1>

      {loading && (
        <div className="font-mono text-xs uppercase tracking-widest text-[#94A3B8]" data-testid="blog-loading">
          Loading transmissions...
        </div>
      )}
      {error && <div className="text-[#EF4444]">{error}</div>}
      {!loading && posts.length === 0 && (
        <div className="border border-[#272E3A] p-10 text-center text-[#94A3B8]" data-testid="blog-empty">
          No posts yet. Check back soon.
        </div>
      )}

      <div className="space-y-6">
        {posts.map((p) => (
          <Link
            key={p.id}
            to={`/blog/${p.slug}`}
            data-testid={`blog-post-${p.slug}`}
            className="group block bg-[#13161C] border border-[#272E3A] hover:border-[#FF5500] transition-colors"
          >
            <div className="grid md:grid-cols-[200px_1fr] gap-0">
              {p.cover_image ? (
                <div
                  className="bg-cover bg-center min-h-[140px] md:min-h-full border-b md:border-b-0 md:border-r border-[#272E3A]"
                  style={{ backgroundImage: `url(${p.cover_image})` }}
                />
              ) : (
                <div className="bg-[#0A0C10] flex items-center justify-center min-h-[120px] md:min-h-full border-b md:border-b-0 md:border-r border-[#272E3A]">
                  <span className="font-mono text-[#272E3A] text-5xl font-black">{`//`}</span>
                </div>
              )}
              <div className="p-6 lg:p-8">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <span className="overline">
                    {new Date(p.updated_at).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}
                  </span>
                  {p.tags && p.tags.length > 0 && (
                    <span className="font-mono text-xs text-[#94A3B8] flex items-center gap-1">
                      <Tag className="w-3 h-3" /> {p.tags.join(" · ")}
                    </span>
                  )}
                </div>
                <h2 className="font-display font-bold text-white text-2xl lg:text-3xl mb-3 tracking-tight group-hover:text-[#FF5500] transition-colors">
                  {p.title}
                </h2>
                <p className="text-slate-400 mb-4 leading-relaxed">{p.excerpt}</p>
                <div className="inline-flex items-center gap-1 font-mono text-xs uppercase tracking-widest text-[#FF5500]">
                  Read post <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
